export default __webpack_public_path__ + "static/wirehead-fm-6cdc27fddd50761460680bd3cb142366.svg";